angular.module('omfm').controller('commandsController', CommandsController);

CommandsController.$inject = ['$scope', 'Commands', '$interval'];

function CommandsController($scope, Commands, $interval) {
	$scope.getList = function(){
		Commands.list({
			type: type
		}, function(data){
			$scope.allCommmands = data;
		});
	};

	$scope.run = function(group, command, client){
		Commands.run({group: group, command: command.type, client: client}, function(){
			command.status = 'Running';
		});
	};

	let type = jQuery("#commands").data('type');

	$scope.getList();

	$interval(function(){
		$scope.getList();
	}, 5000);
}